import { setFaultCategories } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { useMemo } from 'react';
import {
  getSelfTestCategory,
  getSelfTestCategoryIds,
} from '@customer/shared/utils/translationHelpers';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { MultiselectFilter } from './MultiselectFilter';

const useFaultCategoryOptions = (): DropdownItemProps<number>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    const tuples = getSelfTestCategoryIds()
      .map(id => ({ id, label: getSelfTestCategory(t, id) }))
      .sort((a, b) => a.label.localeCompare(b.label));

    return tuples.map(({ id, label }) => {
      const stringValue = id.toString();
      return { key: stringValue, value: id, stringValue, label };
    });
  }, [t]);
};

export const FaultCategoriesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<number>
      filterName="faultCategories"
      label={label ?? t('FaultCategory')}
      action={setFaultCategories}
      elementRef={elementRef}
      useItemsHook={useFaultCategoryOptions}
    />
  );
};

export default FaultCategoriesFilter;
